import CampaignsByCspsContainer from './containers/CampaignsByCspsContainer';
import CampaignsByDcasContainer from './containers/CampaignsByPrimaryDcasContainer';
import CampaignDetail from './containers/CampaignDetail';
import CampaignRedirector from './containers/CampaignRedirector';
import RcsCampaignDetail from './containers/RcsCampaignDetail';
import RcsCampaignsByCsps from './containers/RcsCampaignsByCsps';
import RcsCampaignsByPrimaryDcas from './containers/RcsCampaignsByPrimaryDcas';
import { RCS_CAMPAIGN_ENABLED, TRACKING_REJECTED_CAMPAIGNS } from '@/constants';
import {
  CSP_CAMPAIGN_DETAILS_PATH,
  CSP_CAMPAIGNS_PATH,
  DCA_CAMPAIGN_DETAILS_PATH,
  DCA_CAMPAIGNS_PATH,
  LEGACY_CSP_CAMPAIGN_DETAILS_PATH,
  RCS_CSP_CAMPAIGN_DETAILS_PATH,
  RCS_CSP_CAMPAIGNS_PATH,
  RCS_DCA_CAMPAIGN_DETAILS_PATH,
  RCS_DCA_CAMPAIGNS_PATH,
  WILDCARD_CAMPAIGN_DETAILS_PATH,
  DECLINED_CSP_CAMPAIGNS_PATH,
  DECLINED_DCA_CAMPAIGNS_PATH,
} from '@/constants/paths';
import { Role, RouteConfig } from '@/types';

const AllRoles = Object.values(Role);

const routes: RouteConfig[] = [
  {
    key: 'csp-campaigns',
    path: CSP_CAMPAIGNS_PATH,
    title: '10DLC Campaigns Shared by CSPs',
    component: CampaignsByCspsContainer,
    roles: AllRoles,
  },
  {
    key: 'dca-campaigns',
    path: DCA_CAMPAIGNS_PATH,
    title: '10DLC Campaigns Shared by Primary DCAs',
    component: CampaignsByDcasContainer,
    roles: AllRoles,
  },
  ...(TRACKING_REJECTED_CAMPAIGNS
    ? [
        {
          key: 'csp-declined-campaigns',
          path: DECLINED_CSP_CAMPAIGNS_PATH,
          title: '10DLC Campaigns Shared by CSPs',
          component: CampaignsByCspsContainer,
          roles: AllRoles,
        },
        {
          key: 'dca-declined-campaigns',
          path: DECLINED_DCA_CAMPAIGNS_PATH,
          title: '10DLC Campaigns Shared by Primary DCAs',
          component: CampaignsByDcasContainer,
          roles: AllRoles,
        },
      ]
    : []),
  {
    key: 'campaign-detail',
    path: LEGACY_CSP_CAMPAIGN_DETAILS_PATH,
    title: '10DLC Campaign',
    component: CampaignDetail,
    roles: AllRoles,
  },
  {
    key: 'csp-campaign-detail',
    path: CSP_CAMPAIGN_DETAILS_PATH,
    title: '10DLC Campaign',
    component: CampaignDetail,
    roles: AllRoles,
  },
  {
    key: 'dca-campaign-detail',
    path: DCA_CAMPAIGN_DETAILS_PATH,
    title: '10DLC Campaigns',
    component: CampaignDetail,
    roles: AllRoles,
  },
  ...(RCS_CAMPAIGN_ENABLED
    ? [
        {
          key: 'rcs-csp-campaigns',
          path: RCS_CSP_CAMPAIGNS_PATH,
          title: 'RCS Campaigns Shared by CSPs',
          component: RcsCampaignsByCsps,
          roles: AllRoles,
        },
        {
          key: 'rcs-csp-campaign-detail',
          path: RCS_CSP_CAMPAIGN_DETAILS_PATH,
          title: 'RCS Campaign',
          component: RcsCampaignDetail,
          roles: AllRoles,
        },
        {
          key: 'rcs-dca-campaign-detail',
          path: RCS_DCA_CAMPAIGN_DETAILS_PATH,
          title: 'RCS Campaign',
          component: RcsCampaignDetail,
          roles: AllRoles,
        },
        {
          key: 'rcs-dca2-campaigns',
          path: RCS_DCA_CAMPAIGNS_PATH,
          title: 'RCS Campaigns Shared by Primary DCAs',
          component: RcsCampaignsByPrimaryDcas,
          roles: AllRoles,
        },
        {
          key: 'campaign-redirector',
          path: WILDCARD_CAMPAIGN_DETAILS_PATH,
          title: 'Campaign',
          component: CampaignRedirector,
          roles: AllRoles,
        },
      ]
    : []),
];

export default routes;
